import { AuthnPolicyConsts } from 'client/util/Constants';

const { policyActions } = AuthnPolicyConsts;

const [legacy, allow, allowWithMFA, deny, unknown] = [
  {
    name: 'Require MFA based on user setting',
    value: policyActions.legacy,
  },
  {
    name: 'Allow authentication',
    value: policyActions.allow,
    obligations: { mfa: { required: false } },
  },
  {
    name: 'Allow authentication & require MFA',
    value: policyActions.allowWithMFA,
    obligations: { mfa: { required: true } },
  },
  {
    name: 'Deny access',
    value: policyActions.deny,
  },
  {
    name: '',
    value: policyActions.unknown,
  },
];

const policyOptions = {
  UserPortalFallbackPolicyModel: [allow, allowWithMFA, deny, legacy, unknown],
  SsoApplicationAccessPolicyModel: [allow, allowWithMFA, deny, unknown],
  LdapAccessPolicyModel: [allow, allowWithMFA, deny, unknown],
};

export {
  allow,
  allowWithMFA,
  deny,
  legacy,
};

export default policyOptions;
